export default "__VITE_PUBLIC_ASSET__3c409933__"